'use strict';

const moment = require('moment');

const BaseModel = require('./base');

const DateModel = require('./date');

const SectionModel = require('./section');

const TimeModel = require('./time');

class EventModel extends BaseModel {
  initialize() {
    const eventStartAt = moment.unix(this.get('eventStartsAt'));

    if (!this.getAllowedQuantities()) {
      throw new Error('Invalid availability data');
    }

    const [dateModel, timeModel] = this.buildDateAndTimeModel(this.get('eventDateTimeSummary'));
    let discount, savings;

    if (this.get('priceSummary').discount) {
      discount = this.get('priceSummary').discount.formattedAmount;
    }

    if (this.get('priceSummary').savings) {
      savings = this.get('priceSummary').savings.formattedAmount;
    }

    this.set({
      eventStartAt,
      date: dateModel,
      time: timeModel,
      section: new SectionModel({
        discount,
        discountEnabled: this.get('discountEnabled'),
        price: this.get('priceSummary').price,
        savings,
        title: this.get('section'),
        value: this.get('priceSummary').value,
        seatMapUrl: this.get('seatingMapImageUrl'),
      }),
    });
  }

  getUUID() {
    return this.get('uuid');
  }

  getAllowedQuantities() {
    return this.get('allowedQuantities');
  }

  getDate() {
    return this.get('date');
  }

  getTime() {
    return this.get('time');
  }

  getSection() {
    return this.get('section');
  }

  getTierOrder() {
    return this.get('tierOrder');
  }

  getType() {
    return this.get('eventDateTimeSummary').type;
  }

  buildDateAndTimeModel({ type, date, time }) {
    return [new DateModel({ originalDate: date, type }), new TimeModel({ originalTime: time, type })];
  }
}

module.exports = EventModel;
